import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scopeFormatter',
})
export class ScopeFormatterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Apply formatting only for specific values
    const allowedValues = ['all', 'all_processing', 'all_packaging'];
    if (allowedValues.includes(value)) {
      return value
        .split('_') // Split the string by underscores
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
        .join(' '); // Join words with a space
    }

    // Return the original value if not in the allowed list
    return value;
  }
}
